import baseApp from '@/pages/innerAPP'
// import 'zhs-component-library/dist/style.css'
import './../css/home.css'
import App from './App'
;(async () => {
  const vm = await baseApp(App)
  vm.mount('#app')
})()
